
export const uniq = arr => {
  return Array.from(new Set(arr))
}
